module.exports = __webpack_public_path__ + "static/logo-gifture.1a38a4fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-gifture.png
// module id = 547
// module chunks = 114276838955818